'use client';

import React, { useEffect } from 'react';
import { TasticProps } from '../types';
import Wishlist, { WishlistProps } from 'components/commercetools-ui/organisms/wishlist';

import { ImageProps } from 'frontastic/lib/image';
import { useAccount } from 'frontastic/hooks';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { Link } from 'components/commercetools-ui/organisms/header/types';

const WishlistTastic = ({
  pageTitle,
  emptyStateTitle,
  emptyWishlistSubtitle,
  emptyStateImage,
  categories,
  ...props
}: TasticProps<WishlistProps>) => {
  const { getCountry, getCurrency } = useLocale();
  const { account } = useAccount();

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;
    const dataLayer = new DataLayerOnLoad(currentUrl, 'wishlist', localeData, account);
    dataLayer.setDataLayerOnLoad();
  }, []);

  return (
    <Wishlist
      pageTitle={(pageTitle as string) || ''}
      emptyWishlistTitle={(emptyStateTitle as string) || ''}
      emptyWishlistSubtitle={(emptyWishlistSubtitle as string) || ''}
      emptyWishlistImage={(emptyStateImage as ImageProps) || ''}
      emptyWishlistCategories={(categories as Link[]) || []}
      productLogo={props.data.productLogo}
      isPage={true}
    />
  );
};

export default WishlistTastic;
